import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0265',
    ecrans: ['00-2']
});

